import {Component, inject, input} from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {heroArrowRightStartOnRectangle, heroBars3, heroBell, heroUserCircle} from '@ng-icons/heroicons/outline';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-header',
  imports: [NgIcon],
  providers: [provideIcons({ heroBars3, heroBell, heroUserCircle, heroArrowRightStartOnRectangle })],
  template: `
    <div class="navbar bg-base-100 border-b border-base-300 px-4">

      <!-- Hamburger — visibile solo su mobile -->
      <div class="flex-none lg:hidden">
        <label [for]="drawerId()" aria-label="Apri menu" class="btn btn-square btn-ghost">
          <ng-icon name="heroBars3" size="22" />
        </label>
      </div>

      <!-- Titolo pagina -->
      <div class="flex-1 px-2">
        <span class="text-base font-semibold text-base-content/70 tracking-wide">
          Integrazione Prezzemolo E Vitale
        </span>
      </div>

      <!-- Azioni destra -->
      <div class="flex-none flex items-center gap-1">
        <button class="btn btn-ghost btn-circle" aria-label="Logout" (click)="logout($event)">
          <ng-icon name="heroArrowRightStartOnRectangle" size="20" />
        </button>
      </div>

    </div>
  `,
  styles: ``
})
export class HeaderComponent {
  drawerId = input<string>('admin-drawer');
  auth = inject(AuthService);
  router = inject(Router);

  logout(e: Event): void{
    e.preventDefault();
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
